import {
	templateChoices,
	type TemplateOption,
} from '../../components/template-choice/template-definitions';
import {
	USER_SEGMENTATION_TEAM_TYPE_FINANCE,
	USER_SEGMENTATION_TEAM_TYPE_HR,
	USER_SEGMENTATION_TEAM_TYPE_LEGAL,
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
	USER_SEGMENTATION_TEAM_TYPE_SALES,
	type UserSegmentationTeamTypes,
} from '../../models/user-segmentation';

import { workStyleChoiceMessages } from './work-style-choice-messages';

type FormatMessage = (parameters: { id: string; defaultMessage: string }) => string;

export type WorkStyleChoicePlan =
	| { type: 'skip'; option: TemplateOption }
	| { type: 'choose'; options: TemplateOption[] };

const TEAM_TYPES_WITHOUT_SPRINTS: readonly UserSegmentationTeamTypes[] = [
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
	USER_SEGMENTATION_TEAM_TYPE_HR,
	USER_SEGMENTATION_TEAM_TYPE_LEGAL,
	USER_SEGMENTATION_TEAM_TYPE_FINANCE,
	USER_SEGMENTATION_TEAM_TYPE_SALES,
];

const getFlowOption = (formatMessage: FormatMessage): TemplateOption => ({
	option: {
		...templateChoices.softwareDevelopmentKanban,
		imageSrc: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12P753.svg',
		title: formatMessage(workStyleChoiceMessages.flowTitle),
		subtext: formatMessage(workStyleChoiceMessages.flowDescription),
	},
});

const getSprintsOption = (formatMessage: FormatMessage): TemplateOption => ({
	option: {
		...templateChoices.softwareDevelopmentScrum,
		imageSrc: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12P754.svg',
		title: formatMessage(workStyleChoiceMessages.sprintsTitle),
		subtext: formatMessage(workStyleChoiceMessages.sprintsDescription),
	},
});

export const getWorkStyleChoicePlan = (
	teamType: UserSegmentationTeamTypes,
	formatMessage: FormatMessage,
): WorkStyleChoicePlan => {
	const flowOption = getFlowOption(formatMessage);
	const offersSprints = !TEAM_TYPES_WITHOUT_SPRINTS.includes(teamType);

	if (!offersSprints) {
		return { type: 'skip', option: flowOption };
	}

	return { type: 'choose', options: [flowOption, getSprintsOption(formatMessage)] };
};
